
import { Injectable, Inject } from '@angular/core';

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(PersonWorkplaceDataService.Id, PersonWorkplaceDataService);

    PersonWorkplaceDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class PersonWorkplaceDataService extends base.BaseDataService<Nema.Crew.Model.PersonWorkplace> implements IPersonWorkplaceDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "personWorkplaceDataService";

    public get EntityName(): string {
        return "PersonWorkplace";
    }

    public get EntitiesName(): string {
        return "PersonWorkplaces";
    }
}

export interface IPersonWorkplaceDataService extends base.IDataService<Nema.Crew.Model.PersonWorkplace> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/personworkplaces.dataservice.ts